import { render, staticRenderFns } from "./BrigadeForkliftTrucksIndicator.vue?vue&type=template&id=49177ea4&scoped=true&"
import script from "./BrigadeForkliftTrucksIndicator.vue?vue&type=script&lang=js&"
export * from "./BrigadeForkliftTrucksIndicator.vue?vue&type=script&lang=js&"
import style0 from "./BrigadeForkliftTrucksIndicator.vue?vue&type=style&index=0&id=49177ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49177ea4",
  null
  
)

export default component.exports
import {QIcon,QTooltip} from 'quasar'
component.options.components = Object.assign({QIcon,QTooltip}, component.options.components || {})
